import { parseUnits, formatUnits, } from "viem";
import { getTokenDefinition, } from "@bracket/chainography";
import type { TokenIdentifier, } from "@bracket/types";

export const bi = ( value: number|string, token: TokenIdentifier, ): bigint => {
  const tok = getTokenDefinition(token);
  return parseUnits(value.toString(), tok.decimals);
}